var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasOnboardingV3)?_c('aha-icon',{staticClass:"onboarding__arrow",attrs:{"name":"arrow-tail","width":"23","height":"24","viewBox":"0 0 18 19"},on:{"click":function($event){return _vm.backToOnboardingV3()}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }